namespace $.$$ {

	$mol_style_define( $bog_worm_slider, {
		display: 'block',
		width: '100%',
		margin: { top: '.25rem', bottom: '.25rem', left: 0, right: 0 },
		accentColor: $mol_theme.current,
		cursor: 'pointer',
	} )

}
